import React, { FC, MouseEvent, ReactNode } from 'react';

//components
import AampeTooltip from '../../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

//constants
import aampeTheme from '../../../../constants/aampeTheme';
import ICONS from '../../../../constants/icons';

interface DatasetElementViewProps {
    aampeToolTipTitle: ReactNode;
    datasetFieldSample: string;
    className?: string;
    handleClick?: (e: MouseEvent<HTMLDivElement>) => void;
}
const DatasetElementView: FC<DatasetElementViewProps> = ({
    aampeToolTipTitle,
    datasetFieldSample,
    className,
    handleClick,
}) => {
    return (
        <AampeTooltip arrow title={aampeToolTipTitle} placement="top">
            <Content onClick={handleClick} className={className}>
                <StyledDatsetIcon />
                {datasetFieldSample}
            </Content>
        </AampeTooltip>
    );
};

const Content = styled.span({
    userSelect: 'none',
});

const StyledDatsetIcon = styled(ICONS.datasets)({
    lineHeight: '20px',
    verticalAlign: 'middle',
    margin: aampeTheme.spacing4(0, 1, 0, 0),
    width: '16px',
    height: '16px',
    color: 'inherit',
});

export default DatasetElementView;
